import React from "react";
import {ContainerUserInfo, Infos, Responsive, PageNow} from './styled';
import {Avatar, Menu, MenuItem, MenuProps, withStyles} from "@material-ui/core";
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import {UserContext} from "../../UserContext";
import {useLocation, useNavigate} from 'react-router';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        marginTop: 10
    },
})((props: MenuProps) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: 'transparent',
            '&:hover': {
                backgroundColor: '#f1f1f1'
            },
        },
    },
}))(MenuItem);

const UserBarInfos: React.FC = () => {
    const {userLogout, data} = React.useContext(UserContext);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [title, setTitle] = React.useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const toEdit = () => {
        handleClose();
        navigate('editar/perfil');
    }
    
    // eslint-disable-next-line
    React.useEffect(() => {
        setTitle(document.title);    
        // eslint-disable-next-line
    });

    return (
        <Responsive inicio={location.pathname === '/area-restrita/usuario/inicio'}>
            <ContainerUserInfo>
                <Infos>
                    <PageNow>{title && title.split('-')[0]}</PageNow>
                </Infos>
                <Infos onClick={handleClick}>
                    <Avatar className="pointer" alt={data.sNome} src="/static/images/avatar/perfil.jpg"/>
                    <div className="pointer">
                        <h1>{data.sNome && data.sNome.substring(0,30) + '...'}</h1>
                        <p>{data.sNomeGrupo}</p>
                    </div>
                </Infos>
                <StyledMenu
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <StyledMenuItem onClick={() => toEdit()}>
                        <ListItemIcon>
                            <PersonIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText primary="Editar Perfil"/>
                    </StyledMenuItem>
                    <StyledMenuItem onClick={() => userLogout()}>
                        <ListItemIcon>
                            <ExitToAppIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText primary="Sair"/>
                    </StyledMenuItem>
                </StyledMenu>
            </ContainerUserInfo>
        </Responsive>
    );
}

export default UserBarInfos;